import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { useHistory } from "react-router-dom";

const FlowStep = styled.div`
  display: grid;
  grid-template-columns: 35px 1fr;
  align-items: center;
  grid-gap: 13px;
  cursor: pointer;

  @media (max-width: 1400px) {
    grid-gap: 10px;
  }
`;

const FlowNumber = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  background-color: ${props =>
    props.currentStep ? "rgba(18, 178, 234, 0.2)" : ""};
  border: ${props =>
    props.currentStep ? "" : "solid 1px rgba(119, 121, 132, 0.2)"};
  color: ${props => (props.currentStep ? "#12b2ea" : "#777984")};
`;

const FlowText = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: ${props => (props.currentStep ? "#1f2021" : "#777984")};

  @media (max-width: 1050px) {
    display: ${props => props.setTabletDisplay};
  }
  @media (max-width: 475px) {
    display: none;
  }
`;

const SellFlowItem = ({ item }) => {
  const history = useHistory();
  const [text, setText] = useState("");

  useEffect(() => {
    if (globalThis.innerWidth) {
      setText(
        globalThis.innerWidth < 700 && item.tabletText
          ? item.tabletText
          : item.text
      );
    }
  }, [globalThis.innerWidth]);

  return (
    <FlowStep onClick={() => history.push(item.link)}>
      <FlowNumber currentStep={item.id === 3}>{item.id}</FlowNumber>

      <FlowText
        currentStep={item.id === 3}
        setTabletDisplay={item.id !== 3 ? "none" : "initial"}
      >
        {text}
      </FlowText>
    </FlowStep>
  );
};

export default SellFlowItem;
